import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';

type CategoryTreeItem = {
	children: Array<CategoryTreeItem>;
	has_children: boolean;
	id: number;
	level: number;
	name: string;
	parent_id: number;
	type: string;
}

const ROOT_URL: string = 'api/data/categories-tree/';

@Injectable({
	providedIn: 'root'
})
export class CategoryTreeService {

	constructor(
		private http: HttpClient,
		private httpService: HttpService
	) {}

	getCategoryTree(categories: Array<number>): Promise<Array<CategoryTreeItem>> {
		return this.httpService.getPromise<Array<CategoryTreeItem>>(
			this.http
				.post<{ results: Array<CategoryTreeItem> }>(ROOT_URL, { categories })
				.pipe(
					map((response: { results: Array<CategoryTreeItem> }) => response.results || [])
				)
		);
	}
}